export default "__VITE_ASSET__Dsi7rZe6__"